// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"7ab6156b","732":"6347bf5c"}[chunkId] + ".chunk.js";
};